import * as yup from "yup";
import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";
import { unwrapOr } from "../../utilities/general";

const responseSchema = yup
  .array()
  .of(
    yup.object({
      id: yup.number().required(),
      name: yup.string().required(),
    }),
  )
  .required();

const composeResponse = (res) => {
  const data = unwrapOr(() => res.data.data, {});
  return Object.values(data).map((d) => ({
    id: d.id,
    name: d.clinic_name,
  }));
};

export function useClinicsObOrderQuery({ options = {} }) {
  return useQuery(
    [QUERY_KEYS.clinicsObOrder],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getClinicsObOrder());
      return responseSchema.validateSync(composeResponse(res), {
        strict: true,
      });
    },
    options,
  );
}
